var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col  mt-3"},[_c('div',{staticClass:"el-button-group mb-3"},[_c('router-link',{staticClass:"el-button--medium",attrs:{"tag":"el-button","active-class":"el-button--primary","to":"/teklif/fatura","type":"default"}},[_vm._v(_vm._s(_vm.$t("fatura.fatura"))+"\n    ")])],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3623d2cd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Module/teklif/_route.vue
// module id = null
// module chunks = 